import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {GraphCompanyResponse} from '../models/company-page-response';

export interface GraphService {
    getCompany(): Observable<GraphCompanyResponse>;
}

@Injectable()
export class GraphServiceImpl implements GraphService {
    private http = inject(HttpClient);


    getCompany(): Observable<GraphCompanyResponse> {
        return this.http.get<GraphCompanyResponse>(`/api/graph/company`);
    }
}
